<template>
  <div class="stat-filter login-filter">
    <div class="stat-filter-col">
      <label class="stat-filter-col__label">выбрать <br> режим:</label>
      <v-btn-toggle
        v-model="granularity"
        mandatory
        class="lf-toggle"
      >
        <v-btn value="hour" height="48">
          Часы
        </v-btn>
        <v-btn value="day" height="48">
          Дни
        </v-btn>
      </v-btn-toggle>
    </div>

    <div class="stat-filter-col">
      <label class="stat-filter-col__label">выбрать <br> {{ granularity === 'hour' ? 'окно:' : 'период:' }}</label>
      <v-select
        v-if="granularity === 'hour'"
        v-model="hours"
        :items="hourPresets"
        dense
        outlined
        hide-details
        class="lf-select"
        style="max-width: 200px"
      />
      <v-menu
        v-else
        :close-on-content-click="false"
        offset-y
      >
        <template #activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            class="button-datepicker"
            height="48"
            color="#fff"
            depressed
            v-on="on"
          >
            <font-awesome-icon color="#FF9100" icon="calendar-alt" class="mr-2" />
            <span class="font-weight-light">{{ dateRange[0] }} - {{ dateRange[1] }}</span>
          </v-btn>
        </template>
        <v-date-picker
          v-model="dateRange"
          :first-day-of-week="1"
          range
          no-title
          locale="ru"
        />
      </v-menu>
    </div>

    <div class="stat-filter-col">
      <label class="stat-filter-col__label">устрой- <br> ство:</label>
      <v-chip-group
        v-model="deviceType"
        active-class="lf-chip-on"
        class="lf-chips"
      >
        <v-chip value="">
          Все
        </v-chip>
        <v-chip value="web">
          web
        </v-chip>
        <v-chip value="mobile">
          mobile
        </v-chip>
        <v-chip value="crm">
          crm
        </v-chip>
      </v-chip-group>
    </div>

    <div class="stat-filter-col">
      <v-btn
        class="lf-apply"
        height="48"
        depressed
        color="#D3D5D9"
        @click="apply"
      >
        Применить
      </v-btn>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    name: 'LoginStatFilter',
    data () {
      return {
        granularity: 'hour',
        hours: 48,
        hourPresets: [
          { text: 'Последние 24 ч', value: 24 },
          { text: 'Последние 48 ч', value: 48 },
          { text: 'Последние 72 ч', value: 72 },
        ],
        dateRange: [
          moment().subtract(6, 'days').format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD'),
        ],
        deviceType: '',
      }
    },
    mounted () {
      this.apply()
    },
    methods: {
      apply () {
        const payload = {
          granularity: this.granularity,
          deviceType: this.deviceType || null,
        }
        if (this.granularity === 'hour') {
          payload.hours = this.hours
        } else {
          payload.dateRange = [...this.dateRange].sort()
        }
        this.$emit('apply', payload)
      },
    },
  }
</script>

<style lang="less" scoped>
.stat-filter {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 18px;
  padding: 12px 18px;
  background: #f1f3f6;
  border-radius: 8px;
  margin-bottom: 30px;

  .media-sm({
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  });
}

.stat-filter-col {
  display: flex;
  align-items: center;

  &__label {
    line-height: 1.1;
    margin-right: 14px;
    color: #949191;
    font-size: 14px;
    white-space: nowrap;
  }

  .media-sm({
    width: 100%;

    .lf-toggle,
    .lf-select,
    .lf-chips,
    .button-datepicker,
    .lf-apply {
      width: 100%;
      max-width: none !important;
    }
  });
}

.button-datepicker {
  border-radius: 10px;
  text-transform: none;
  letter-spacing: normal;

  span {
    font-size: 13px;
  }
}

.lf-apply {
  border-radius: 10px;
  font-weight: 500;
  letter-spacing: normal;
}

::v-deep .lf-toggle {
  border-radius: 10px;
  overflow: hidden;
  background: #fff;

  .v-btn {
    border: 1px solid #e3e6ec;
    letter-spacing: normal;
    text-transform: none;
    font-weight: 500;
    min-width: 64px;
    background: #fff !important;
  }

  .v-btn--active {
    background: #FF9100 !important;
    color: #fff !important;
    border-color: #FF9100 !important;
  }
}

::v-deep .lf-select {
  .v-input__slot {
    background: #fff;
    border-radius: 10px;
    min-height: 48px !important;
  }

  fieldset {
    border-color: #e3e6ec;
  }
}

::v-deep .lf-chips {
  .v-chip {
    border-radius: 9px;
    background: #fff;
    border: 1px solid #e3e6ec;
    color: #6d6d6d;
    font-weight: 500;
  }

  .lf-chip-on {
    background: rgba(255, 145, 0, 0.14) !important;
    border-color: #FF9100 !important;
    color: #FF9100 !important;
  }
}
</style>
